/**
 * ブラックリストの共通画像URL
 */
export const COMMON_IMG_URL = 'https://www.tbs.co.jp/tbs-ch/img/default-thumbs/608.jpg';
